import React from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent
} from "@ionic/react";
import { arrowBack } from "ionicons/icons";
import { IonIcon } from "@ionic/react";
import { ActiveSelect } from "../../common/constants";
import { REST_PILOT_URL } from "../../common/constants";
import PilotROList from "../../pilot/PilotROList";
import { findPilotFce } from "../../common/FindFuctions";

/**
 * Pilot selection view component
 */
export const PilotSelectionView = ({
  type,
  active,
  onBack,
  onSelectPilot,
  onClearPilot
}) => {
  let isLifter = false;
  let selectMessage = "Vyber pilota";

  if (type === ActiveSelect.FIRST) {
    selectMessage = "Vyber prvního pilota kluzáku";
  } else if (type === ActiveSelect.SECOND) {
    selectMessage = "Vyber druhého pilota kluzáku";
  } else if (type === ActiveSelect.LIFTER) {
    isLifter = true;
    selectMessage = "Vyber vlekaře";
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons>
            <IonButton slot="start" color="primary" onClick={onBack}>
              <IonIcon icon={arrowBack} /> Zpět
            </IonButton>
            <IonTitle size="small">{selectMessage}</IonTitle>
            {type === ActiveSelect.SECOND && (
              <IonButton color="primary" slot="end" onClick={onClearPilot}>
                Žádný pilot
              </IonButton>
            )}
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <PilotROList
          key="pilotList"
          resourceUrl={REST_PILOT_URL}
          view={type}
          active={active}
          setPilot={onSelectPilot}
          findFce={findPilotFce}
          loadApiQuery={`active=true${isLifter ? '&lifter=true' : ''}`}
        />
      </IonContent>
    </IonPage>
  );
};

